import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';

let stompClient = null;
let reconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 5;
const RECONNECT_INTERVAL = 3000; // in ms

export function connectWebSocket(onConnect) {
  const token = localStorage.getItem('accessToken');

  stompClient = new Client({
    webSocketFactory: () =>
      new SockJS('https://backend-stage.makersharks.ai/ws'),
    connectHeaders: {
      'x-auth-token': localStorage.getItem('accessToken'),
    },
    debug: (str) => {
      // console.log('[STOMP DEBUG]', str);
    },
    reconnectDelay: 0,
    onConnect: () => {
      console.log('✅ Connected to WebSocket');
      reconnectAttempts = 0;
      onConnect(stompClient);
    },
    onStompError: (frame) => {
      console.error('STOMP Error:', frame.headers['message'], frame.body);
    },
    onWebSocketClose: () => {
      console.log('WebSocket closed');
      handleReconnect(onConnect);
    },
    onWebSocketError: (event) => {
      console.error('WebSocket error:', event);
      handleReconnect(onConnect);
    },
  });

  stompClient.activate();
}

function handleReconnect(onConnect) {
  if (reconnectAttempts < MAX_RECONNECT_ATTEMPTS) {
    reconnectAttempts++;
    console.log(
      `🔁 Reconnect attempt ${reconnectAttempts}/${MAX_RECONNECT_ATTEMPTS}`,
    );
    setTimeout(
      () => connectWebSocket(onConnect),
      RECONNECT_INTERVAL * reconnectAttempts,
    );
  } else {
    console.error('❌ Max reconnection attempts reached.');
  }
}

export function sendMessage(message) {
  if (stompClient && stompClient.connected) {
    stompClient.publish({
      destination: '/app/chat.sendMessage',
      body: JSON.stringify(message),
    });
    return true;
  }
  return false;
}

export function markMessagesAsRead(roomId, readerType, readerId) {
  if (stompClient && stompClient.connected) {
    stompClient.publish({
      destination: `/app/chat.markRead/${roomId}`,
      body: JSON.stringify({ readerId, readerType }),
    });
    return true;
  }
  return false;
}

export function sendTypingStatus(roomId, userId, isTyping) {
  if (stompClient && stompClient.connected) {
    stompClient.publish({
      destination: `/app/chat.typing/${roomId}`,
      body: JSON.stringify({ userId, isTyping }),
    });
    return true;
  }
  return false;
}

export function disconnectWebSocket() {
  if (stompClient) {
    stompClient.deactivate();
    console.log('🛑 WebSocket disconnected');
  }
}

export function unsubscribe(subscriptionId) {
  if (stompClient && stompClient.connected && subscriptionId) {
    stompClient.unsubscribe(subscriptionId);
    return true;
  }
  return false;
}
